<template>
  <v-app>
    <v-card class="bgs rounded-0 d-flex justify-center" flat width="100%" height="100%">
      <v-container>
        <h2 class="text-center mt-6 font24 mb-4">
          {{ $t("Taoify 服务条款") }}
        </h2>
        <p class="content mt-4">
          {{ $t("提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 服务条款》（以下简称\"本服务条款\"），重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本服务条款约束。") }}
        </p>
        <p class="content">
          {{ $t("Taoify有权不定期更新、修改本服务条款里的内容，有权在 Taoify 网站上发布更新和修改更新本服务条款。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。") }}
        </p>
        <p class="content">
          {{ $t("您完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括《Taoify 用户使用协议》《Taoify用户隐私政策》。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。") }}
        </p>

        <h3 class="titlee">{{ $t("一、定义") }}</h3>
        <ul>
          <li>{{ $t("1、服务：Taoify 为您提供独立站搭建、店铺管理、订单收款、配套工具等建站经营服务，用于商户面向境外消费者销售商品、提供服务。") }}</li>
          <li>{{ $t("2、用户或您：指完成 Taoify 平台注册，并使用平台各项服务的自然人、法人及其他组织，包括但不限于商店所有者及\"员工账户\"下的用户。") }}</li>
          <li>{{ $t("3、平台：指Taoify 运营企业及平台软硬件系统、网站、服务端口等整体服务载体。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("二、通用运营规则") }}</h3>
        <ul>
          <li>{{ $t("1、Taoify 服务相关的技术支持仅对已完成注册的有效商户开放。") }}</li>
          <li>{{ $t("2、因法律法规调整、服务优化、平台运营调整等，我方有权修订、增补本服务条款、用户使用协议、隐私政策等全部 Taoify 平台规则，亦有权调整或关停平台服务、终止您账户；服务终止不影响终止日前双方已产生的各项权利与义务。") }}</li>
          <li>{{ $t("3、您认可并同意 Taoify 可以通过在商城发布相关的修正或新增的任何条款，修订提前1个工作日在平台公示，资费调整提前1个月公示，在网站公示后的七（7）日公示期后生效。如果您在公示期间没有提出异议或在生效日后继续使用服务即表示您同意并接受此修订版。") }}</li>
          <li>{{ $t("4、您不得将服务用于任何非法目的，您在使用本服务期间须严格遵守经营所在地、客户所在地及中华人民共和国全部现行法律法规（包括但不限于版权相关法律）。") }}</li>
          <li>{{ $t("5、您须对本人名下 API 证书的使用行为承担全部责任，并妥善保管 API 证书，保障其使用安全。") }}</li>
          <li>{{ $t("6、未经 Taoify 书面许可，您不得对Taoify 平台、服务的任何部分进行任何形式的再生产、修改、编辑、破解、反编译、反向工程、拆解、改编、衍生开发等操作；不得修改源代码、默认模板、自带文档、功能模块、接口程序等与系统相关的任何内容；不得复制、销售、转售或以此牟利。") }}</li>
          <li>{{ $t("7、您不得注册、购买或使用包含 Taoify、Taoify 商标，以及该商标衍生变体、近似错拼词汇的域名；亦不得将前述相关词汇用于搜索引擎推广或其他按点击付费广告（如谷歌广告）。") }}</li>
          <li>{{ $t("8、有关本服务条款的任何问题，请发邮件到 liutaotao@taocarts.com。") }}</li>
          <li>{{ $t("9、您知晓您的资料（不包括信用卡信息）可能未经加密转移，并涉及通过各种网络传输。") }}</li>
          <li>{{ $t("10、平台有关条款（包括但不限于本服务条款等）可能会有除中文以外的其他版本。如果不同语言版本的服务条款之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本服务条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本服务条款，予以明确排除。") }}</li>
          <li>{{ $t("11、本服务条款对双方、双方各自的继承人、权利义务承继人、合法受让方及法定代表人均具备约束力。Taoify 可无需向您发出通知、亦无需取得您同意，自行转让本服务条款项下全部权利义务。未经 Taoify 事先书面许可，您不得将本服务条款，或您在本协议项下享有的任何权利、承担的任何义务转让、变相转移予任何第三方。") }}</li>
          <li>{{ $t("12、若因任何事由致使本服务条款任一完整条款或条款部分内容无效，仅该条款或对应部分丧失效力，其余所有条款效力不受影响。") }}</li>
          <li>{{ $t("13、无论您申请注销账号、还是平台因违规终止合作，本服务条款商业秘密保护约定、权责划分与损失赔偿规则、第三方服务风险兜底、知识产权相关约定、争议管辖与法律适用、费用结算、侵权赔付、数据合规相关全部条款仍具备法律效力，不受服务终止影响。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("三、账户管理规范") }}</h3>
        <ul>
          <li>{{ $t("1、您注册 Taoify 账号时必须提供合法完整姓名、现地址、电话号码、有效的电子邮件地址以及其他所需的任何信息。Taoify 有权基于任何理由拒绝您的账号申请或注销现有账户。") }}</li>
          <li>{{ $t("2、您必须年满18岁或达到您使用本服务所在地或经营所在地的法定成年的年龄。") }}</li>
          <li>{{ $t("3、您承诺是为经营之商业目的使用Taoify 服务，不得将账号、店铺用于个人日常消费、家庭自用等非经营场景。") }}</li>
          <li>{{ $t("4、店铺的创建与运营过程中的全部负责由您自行承担。") }}</li>
          <li>{{ $t("5、Taoify 仅提供独立站建站技术工具，不介入您与第三方之间的订单、售后、货款往来，您与第三方进行的直接交易，相关纠纷均与 Taoify 无关，我方不承担任何调解、赔付责任。") }}</li>
          <li>{{ $t("6、您对账户内所有操作行为，以及账户内上传、收集、生成、存储、展示、分发、传输的全部内容（包括图片、视频、图文素材、音频、代码、信息、数据等）承担全部责任。") }}</li>
          <li>{{ $t("7、若因用户违反本协议约定，导致平台被第三方索赔、起诉、仲裁，或被行政机关处以罚款、责令赔付，全部责任均由用户独立承担。用户须向平台足额赔付平台由此产生的全部直接损失与间接损失，损失范围包括但不限于：平台向第三方支付的赔偿金、和解金、补偿金、违约金；行政机关、司法机关收取的罚款、滞纳金、诉讼费、仲裁费、保全费、执行费、鉴定费、评估费；平台为维权支出的律师费、公证费、调查取证费、差旅费、担保费；平台商誉受损损失、业务中断损失、可得利益损失、第三方追责产生的额外赔付等一切相关费用。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("四、账户管理") }}</h3>
        <p class="content">{{ $t("1、Taoify 账户商店所有者") }}</p>
        <p class="content">{{ $t("1.1 完成注册服务的用户将是商店所有者，并且将被授权使用我方提供给商店所有者的相关服务。您需保证营业执照、行政许可、审批、备案、资质等注册资料，在店铺页面清晰公示，供监管部门、消费者核验。") }}</p>
        <p class="content">{{ $t("1.2 若您代表第三方注册本服务，则第三方为商店所有者。您必须使用第三方名下或者指定的邮箱完成注册，同时声明并保证已取得第三方合法书面授权且有效，提交授权许可手续，明确已授权范围，包括但不限于授权注册、日常登录、授权认可并自愿接受Taoify 平台所有协议、条款等。") }}</p>
        <p class="content">{{ $t("1.3 注册账户后，若您需在店铺内上架、展示、销售第三方品牌商品或服务，您须提前向平台提交品牌授权书、经销许可、使用许可等合法有效手续，并保证相关授权、许可持续有效。未按要求提供手续或授权失效的，平台有权下架对应商品、暂停服务直至终止账户，由此产生的全部法律责任与损失由您自行承担。") }}</p>
        <p class="content">{{ $t("1.4 一个 Taoify 商店只能有一名商店所有者，一名商店所有者可以有多家 Taoify 商店。\"商店\"表示与账户相关联的在线商店或者实体零售地点。") }}</p>
        <p class="content">{{ $t("2、员工账户") }}</p>
        <p class="content">{{ $t("2.1 根据您订阅的 Taoify 套餐，您可以创建一个或多个员工账户，商店所有者必须设置权限，限制员工账户对业务数据、店铺功能的访问范围（例如限制查看销售报表、禁止修改店铺基础设置等）。") }}</p>
        <p class="content">{{ $t("2.2 凡使用本平台为门店开立的员工账号所实施的全部行为，由此产生的一切法律责任、经济损失及相应后果，均由商店所有者承担；前述员工账号操作行为，视同商店所有者作出的行为。") }}</p>
        <p class="content">{{ $t("3、收款结算账户") }}</p>
        <p class="content">{{ $t("3.1 注册成功后，Taoify 将提供多家支付服务商供您进行选择。您可以从中选择收取顾客款项的渠道。") }}</p>
        <p class="content">{{ $t("3.2 您须自行负责注册、激活及维护收款账户，自行承担收款账户需承担费用。如果您不再需要这些收款账户，您须自行关停账户。支付服务商属于本服务条款中的第三方服务。") }}</p>
        <p class="content">{{ $t("3.3 您在店铺内使用收款账户，即视为您同意遵守对应支付服务商的服务条款与规则；支付服务商可随时修订条款，修订内容一经公示即刻生效。若您在条款修订公示完成后，继续使用店铺收款账户开展业务操作，即代表您认可并完全接受修订后的全部条款内容。若您不认可条款变更，须立即注销收款账户，并停止使用该支付服务。") }}</p>

        <h3 class="titlee">{{ $t("五、Taoify权利") }}</h3>
        <ul>
          <li>{{ $t("1、我方保留随时修改、暂停、终止全部或部分平台服务的权利，且无需提前通知用户。部分服务、功能并非在所有国家/地区使用，我方无义务在任意区域提供指定服务。") }}</li>
          <li>{{ $t("2、Taoify 拥有自主选择权，保留拒绝向任意主体提供平台服务的权利。") }}</li>
          <li>{{ $t("3、如果我方判定店铺提供的商品或服务或者发布到店铺的资料违反了 Taoify 的协议，包括但不限于《Taoify 用户使用协议》《Taoify用户隐私政策》、本服务条款等，我方有权要求整改、删除违规内容、暂停或永久终止全部服务，用户已缴纳的所有费用不予退还。") }}</li>
          <li>{{ $t("4、凡以口头、书面其他任何形式辱骂 Taoify 客户、员工、工作人员，或打击报复类威胁言论的，其账户将被立即永久终止使用，用户已缴纳的所有费用不予退还。") }}</li>
          <li>{{ $t("5、平台内容由您负责、承担责任，Taoify 不预先审核用户发布内容，我方有权自行裁量，单方拒绝展示或删除平台内任意内容，Taoify 无提前告知义务。") }}</li>
          <li>{{ $t("6、Taoify 可向您的同业竞争者提供服务，不向任何用户授予细分市场独家合作权益。您确认并同意，Taoify 的合作方及员工均有可能成为 Taoify 平台客户或入驻，前述主体可能与您开展同业竞争，但严禁擅自使用您保密信息。") }}</li>
          <li>{{ $t("7、若就商店所有者权属产生争议，我方有权要求相关方提交权属证明文件，包括但不限于营业执照扫描件、政府机关核发的有效身份证件、信用卡后四位卡号、在职证明等资料。") }}</li>
          <li>{{ $t("8、依据现有材料，我方有权判定账户的商店所有者，并有权根据我方的单方判断将账户转让给商店所有者，若您有异议，请及时提出转让异议。如果我方无法判定账户合法所有者或者收到转让异议，Taoify 有权临时冻结该账户，直至争端双方直至争议各方达成纠纷解决方案。") }}</li>
          <li>{{ $t("9、Taoify平台无需就您遭受的任何直接损失、间接损失、商誉损失、预期收益损失、经营利润损失等承担任何赔偿责任。") }}</li>
          <li>{{ $t("10、若存在法定或其他 Taoify 应当承担赔偿责任的情形，Taoify 对用户的全部累计赔偿责任（含违约金、赔偿金、维权支出）最高限额为：损失事件发生对应服务周期内，您实际向 Taoify 支付的服务费总金额。无论索赔事由多少、损失金额高低，合计赔付总额不得突破该上限。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("六、责任限制") }}</h3>
        <ul>
          <li>{{ $t("1、您保证符合合法经营资质（包括但不限于营业执照、行政审批等）、保证商品质量合格、保证图文与实际物品规则、质量、功能等一致，不存在虚假宣传、不正当竞争等；") }}</li>
          <li>{{ $t("2、在现行法律允许的最大范围内，因平台服务无法使用、系统故障产生的各类经营损失，平台及服务商均无需承担赔偿，包括经营收入减少、客户流失、品牌口碑受损、数据丢失、预期收益下滑等各类直接、间接经济损耗与衍生损失。") }}</li>
          <li>{{ $t("3、若您存在违反本服务条款及《Taoify 用户使用协议》《Taoify用户隐私政策》、违反法律法规或侵害第三方合法权益的行为，您须保障 Taoify及其关联主体、合作方、员工及供应商免受一切索赔追责，并须全额赔付 Taoify 及其关联方、合作方、员工、供应商遭受的全部损失、诉讼费、律师费。") }}</li>
          <li>{{ $t("4、您使用本服务需要自担风险。平台以\"现状\"提供服务，不作出任何书面、口头经营收益、系统稳定类承诺。") }}</li>
          <li>{{ $t("5、Taoify 不保证服务及时、安全、零差错、不间断运行。") }}</li>
          <li>{{ $t("6、Taoify 不保证使用本服务所输出、取得的结果具备准确性与可靠性。") }}</li>
          <li>{{ $t("7、因您使用本服务产生的全部税费缴纳义务，均由您自行承担并缴纳，Taoify 不承担任何相关责任。") }}</li>
          <li>{{ $t("8、Taoify 不保证平台产品、服务、信息符合您的预期，亦无义务修复服务内全部漏洞、差错。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("七、知识产权约定") }}</h3>
        <ul>
          <li>{{ $t("1、您上传至 Taoify 服务平台的图片、文案、商标、素材知识产权、所有权归您所有，您须保证上传图片、文案、商标、素材不侵犯任何第三人知识产权等权益，须确保前述内容符合全部法律法规。您可随时注销账户，同步清除其 Taoify 店铺内全部相关素材，清除后即无法恢复。") }}</li>
          <li>{{ $t("2、您上传内容即视为同意下述约定：2.1 允许其他主体免费查阅您上传至 Taoify 店铺的全部内容；2.2 就您公开发布的内容，授予 Taoify 存储、免费展示及免费使用该等内容；2.3 Taoify 有权核查、删除您上传至本平台服务的任意内容，但并无开展前述操作的强制性义务。2.4 Taoify可免费使用与您店铺相关的商号、注册商标、服务标识及品牌标识，用于推广、宣传 Taoify 平台服务。") }}</li>
          <li>{{ $t("3、平台系统、程序（包括但不限于源代码、框架、设计、文档）、界面、官方文档等所有知识产权归平台所有，未经书面授权不得复制、传播、二次开发。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("八、商品发货与物流规则") }}</h3>
        <p class="content">
          {{ $t("对于您Taoify商铺所售出的商品，您可以在发货时选择联系第三方承运商提供商处购买运输标签。商品发货、物流运输相关事宜、费用、风险均由您自行负责，Taoify不承担任何责任。") }}
        </p>

        <h3 class="titlee">{{ $t("九、商店主题规范") }}</h3>
        <ul>
          <li>{{ $t("1、平台提供的店铺模板页面可展示平台官方标识；如模板内页面内容违反平台各项管理规则，平台有权单方面调整页面内容，无义务提前通知商家，但平台无开展前述操作的强制性义务。") }}</li>
          <li>{{ $t("2、平台主题模版的知识产权仍属于设计者。您仅可在授权范围内使用；若超出授权范围使用，设计者可依法追责，平台亦有权修改店铺内容或关停账户，不利后果由您承担，Taoify 不承担任何责任。") }}</li>
          <li>{{ $t("3、技术支持工作由设计者负责，Taoify 不承担提供此类支持的责任，但 Taoify 可帮助您联系设计者。") }}</li>
          <li>{{ $t("4、您安装新模板时，必须自行做好数据备份，Taoify 无备份义务。因安装模板导致原有主题、界面、数据等内容损坏的，Taoify 不承担赔偿责任。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("十、费用支付规则") }}</h3>
        <ul>
          <li>{{ $t("1、您必须向我方提供有效可用的支付方式，以避免扣款失败影响店铺使用。建议您绑定多张信用卡并授权使用自动支付。账单支付的技术由第三方专业金融公司提供技术支持。") }}</li>
          <li>{{ $t("2、账单生成后，系统将通过您授权的支付方式自动扣款，该扣款流程持续至本服务终止。若您设置默认支付卡，系统将优先从默认卡完成扣费。除另行约定外，所有费用均以美元作为结算及支付币种。") }}</li>
          <li>{{ $t("3、费用将显示在账单上，并通过提供的电子邮件发送至商店所有者。如果您对账单存在疑问，可以与 Taoify 的相关业务部门进行联系。后续将通过电子邮件的形式与您取得联系，账单争议内容将发送至您所提供的店铺财务邮箱。") }}</li>
          <li>{{ $t("4、针对 Taoify 自身收取的平台服务费，可联系平台对应业务部门办理，发票将通过邮件发送至您预留的店铺财务邮箱；第三方收取的款项，您应直接对接第三方主体办理，Taoify 可予以必要配合。") }}</li>
          <li>{{ $t("5、订阅费用采用预付制，系统将在服务到期前5个自然日自动发起续费扣款。例：服务到期时间为2022-01-06 23:59:59，则预计续费扣费时间为2022-01-01 23:59:59。") }}</li>
          <li>{{ $t("6、我方提前30日发出服务费用变更通知后即可调整服务收费标准，我方可通过平台官网公告或您店铺后台管理页面公示的方式送达该通知。") }}</li>
          <li>{{ $t("7、我方不会就关于服务的任何修改、价格变动、暂停或终止对您或任何第三方承担任何责任。") }}</li>
          <li>{{ $t("8、若我方无法通过授权银行卡成功扣取订阅费用，将向您所有者发送邮件告知扣款失败，并提示更新支付银行卡。我方每间隔24小时重复发起扣费，总计最多三次扣款尝试（含首次扣款）。第三次扣款仍失败的，我方有权暂停并限制您账户使用权限。您缴清全部未结清款项及下一计费周期订阅费用后，账户方可恢复正常访问权限。") }}</li>
          <li>{{ $t("9、服务期限届满前您未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。") }}</li>
          <li>{{ $t("10、Taoify 自行收取的平台服务费不包含各类政府征收的税金、规费及其他收费（本服务条款中统称为\"税费\"）。除平台服务费外，您因订阅、采购 Taoify 产品与服务产生的全部适用税费，均由您自行承担。税费将依据您提供的账单地址适用税率核算，并从您授权支付卡自动扣取。若您具备免税资格，须向我方提交有效免税凭证；部分司法辖区要求提供能够证实免税资质、符合当地法规的官方证明文件，免税政策自材料审核通过之日起生效。若 Taoify 未代为计收相关税费，您必须自行判断自身纳税义务，由您向税务主管机关完成申报缴纳税款。") }}</li>
          <li>{{ $t("11、除 Taoify 代为收取并上缴主管税务机关的税费外，法律法规规定的各类税款扣除、预提代缴义务均由您自行承担，并由您单独向对应税务机关完成缴纳。无论是否存在前述税款扣除或预提要求，Taoify 均有权按照本服务条款约定，从您授权支付卡扣收全部应付费用，但Taoify无主动扣费义务。") }}</li>
          <li>{{ $t("12、您店铺经营销售行为产生的全部适用税费，均由您自行承担并依法缴纳。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("十一、保证金支付") }}</h3>
        <ul>
          <li>{{ $t("1、您完成 Taoify 账户注册时，须一次性足额缴纳经营保证金1000元。") }}</li>
          <li>{{ $t("2、保证金仅用于担保您履行本服务条款及《Taoify 用户使用协议》《Taoify用户隐私政策》等全部 Taoify 平台规则、全部义务，不能抵扣服务费用、税费。") }}</li>
          <li>{{ $t("3、若您出现商品质量违规、虚假宣传、侵害消费者权益、侵权、行政处罚、违约欠款、第三方索赔、产生赔付款项、依据平台规则须向我方赔偿等情形，您同意我方有权直接从您已缴纳的保证金中抵扣对应赔偿金、罚款、欠款、维权支出、律师费、诉讼费等全部应付费用。保证金经抵扣后余额不足约定标准金额的，您须在我方发出补缴通知后3个自然日内补足差额，恢复保证金足额标准；逾期未足额补缴的，Taoify 有权暂停店铺全部经营功能、限制账户操作，直至保证金足额补齐。") }}</li>
          <li>{{ $t("4、在您主动申请注销账户、结清全部欠款、无未了结客诉、质量纠纷、行政处罚、侵权索赔后，我方将无息退还剩余保证金。存在未结清赔付、纠纷、处罚的，平台有权扣除对应款项后再无息退还剩余部分，不足部分平台保留向您追偿的权利。保证金不产生任何利息，我方无义务为保证金支付利息。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("十二、账户注销与服务终止") }}</h3>
        <ul>
          <li>{{ $t("1、服务期内您主动申请终止服务的，需提前一个月书面通知 Taoify 平台，已缴纳费用不予退还；用户擅自终止协议造成 Taoify 平台损失的，须予以赔偿，包括但不限于直接损失、间接损失、律师费等。") }}</li>
          <li>{{ $t("2、您在暂停使用、注销账户或终止服务前，须自行备份留存账户内全部数据，Taoify 无义务保管您账户相关数据资料。") }}</li>
          <li>{{ $t("3、无论因何种事由任意一方终止本服务，Taoify 将即刻停止提供服务，您亦无法继续登录使用账户。除本服务条款另有约定外，您已缴纳费用不再退还。您因使用平台服务所欠付 Taoify 的全部款项立即届至清偿期，须一次性全额付清，同时您的 Taoify 店铺将被关停下架。") }}</li>
          <li>{{ $t("4、服务终止后，与域名相关的全部事宜由您自行对接域名服务商处理。") }}</li>
          <li>{{ $t("5、服务终止当日，若您存在未结清款项，我方将通过邮件向您发送最终账单，我方不再另行收取任何费用，也不再提供任何服务。") }}</li>
          <li>{{ $t("6、服务无论因何种原因终止，您须自行完整留存店铺经营全部资料（包括但不限于订单记录、商品资质、购销合同、品牌授权、物流凭证、客户交易台账、质检报告等）并自行备案存档，我方无义务代为保管、整理、备案任何资料。") }}</li>
          <li>{{ $t("7、即便服务终止，若您销售的商品、提供的服务存在质量缺陷、侵权、售后纠纷、行政处罚、消费者索赔等全部问题，相关法律责任、赔偿责任、整改义务仍全部由您独立承担，我方不承担任何责任。") }}</li>
          <li>{{ $t("8、如果我方怀疑您涉嫌任何欺诈行为（通过判决、和解、保险、托管调查或其他方式），我方有权暂停或终止您的账户，且我方可采取任何其他补救措施。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("十三、第三方工具、支付服务商规则") }}</h3>
        <ul>
          <li>{{ $t("1、Taoify可提供并开放第三方软件、应用程序、产品、服务接口及网站链接（前述统称\"第三方服务\"，下同），您自主选择开通使用，您与第三方服务商形成独立合作关系，平台不参与双方权利义务约定，不对第三方产品做背书或质量担保，不存在联营、隶属合作关系。") }}</li>
          <li>{{ $t("2、对于使用第三方服务产生的风险，由您自行承担，您在使用第三方服务前先阅读第三方隐私政策、服务条款。Taoify 会从第三方服务提供商处获得收益份额，但该收益获取行为不代表 Taoify 需对第三方服务承担任何担保、赔偿等相关责任。") }}</li>
          <li>{{ $t("3、Taoify有权自主决定随时限制、关闭第三方服务访问权限，且无需提前通知；因暂停或禁用第三方服务产生的一切损失，Taoify 不向任何主体承担责任。第三方服务仅作参考，不可替代专业咨询。") }}</li>
          <li>{{ $t("4、您绑定第三方工具并开启数据互通后，第三方可读取对应店铺经营数据，您与第三方之间的数据交互仅约束双方数据传输，存储风险由您自行承担，平台不会为第三方的数据泄露、篡改行为承担赔偿责任。") }}</li>
          <li>{{ $t("5、Taoify 有权直接或间接获取您与第三方服务商往来的全部邮件内容。Taoify 可向第三方服务商披露、共享您提交的联络方式及相关背景资料。") }}</li>
          <li>{{ $t("6、因第三方或您与第三方服务商合作关系引发的一切直接、间接以及其他损失，Taoify 均不承担任何赔偿责任。即便提前告知风险，该免责条款仍有效。") }}</li>
          <li>{{ $t("7、您与第三方产生纠纷引发平台被起诉、索赔、行政处罚的，您需全额赔偿平台全部损失、维权开支，保障平台各方不受追责。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("十四、内测Beta功能规则") }}</h3>
        <ul>
          <li>{{ $t("1、平台不定期定向邀请商户体验未正式上线的Beta内测功能，内测使用需同步遵守单独下发的内测补充规则。内测相关资料、沟通记录属于平台保密信息，适用本条款保密有关约定。") }}</li>
          <li>{{ $t("2、未经平台书面许可，商户不得在任何社交平台等渠道发布内测截图、功能细节等与内测有关的内容，禁止向任何第三方泄露内测相关内容。") }}</li>
          <li>{{ $t("3、Taoify不对Beta测试服务的功能作出任何明示或默示陈述或保证。内测功能不代表最终上线版本，平台有权根据开发需求调整、下线甚至永久放弃该功能上线；商家自愿参与测试产生的店铺故障、经营损耗等全部风险由商家自行承担，平台不提供补偿或赔付。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("十五、商户评价规范") }}</h3>
        <ul>
          <li>{{ $t("1、Taoify 欢迎您提交功能优化创意、经营改进建议、第三方工具评价。您向 Taoify 提供的全部创意、建议、配套资料、评价，Taoify 无需保密，无需向您支付任何报酬或补偿。您主动提交反馈、公开评价，即同意Taoify 无偿参考、落地优化相关方案，可按需修改后商用。") }}</li>
          <li>{{ $t("2、您向 Taoify 提交的所有评论，均须如实撰写，不得包含违法、低俗色情、恐吓、诽谤、侵害知识产权以及其他损害第三方权益、引人不适的内容。Taoify有权自主删除违规评价，但无必须开展删除、编辑操作的义务；同时 Taoify 不承担定期核查用户已发布反馈内容的责任。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("十六、第三方权利限制") }}</h3>
        <p class="content">
          {{ $t("除Taoify、Taoify关联企业、注册商户、合法权利受让方以外，未参与本协议签约的自然人、企业，无权依据本条款向平台主张任何权利，不能要求平台强制履行协议约定。") }}
        </p>

        <h3 class="titlee">{{ $t("十七、隐私和数据保护") }}</h3>
        <p class="content">
          {{ $t("Taoify 非常重视对您的个人信息的隐私保护，您使用平台服务即认可平台按照《隐私政策》收集、存储、使用客户个人信息。若商户面向欧盟经济区消费者经营、向欧盟客户销售商品、需要遵守 GDPR 法规，双方另行签署《数据处理补充协议》规范跨境数据传输行为。") }}
        </p>

        <h3 class="titlee">{{ $t("十八、商业秘密保护") }}</h3>
        <ul>
          <li>{{ $t("1、商业秘密：指双方获取、接触到的对方未对外公开的经营与技术资料，涵盖客户资源、潜在客户联系方式、产品研发方案、定价体系、经营成本、营销方案、内部运营流程、专属技术方案、未对外公示财务数据等一切具备商业价值的非公开资料，无论资料是否标注\"保密\"字样。平台内部运维方案、系统安全机制等内部资料同样属于平台商业秘密。") }}</li>
          <li>{{ $t("2、保密义务要求：仅能基于履行本协议约定经营事项使用对方商业秘密，同时采取与自身内部保密同等力度的防护手段，严防商业秘密泄露、复制、擅自对外流转：2.1 仅允许岗位必需员工接触涉密资料，并通过内部制度约束员工保守商业秘密；2.2 如收到法院、监管机关强制调取涉密资料的通知，在法律允许范围内第一时间书面告知资料持有方，并尽可能缩小信息披露范围。") }}</li>
          <li>{{ $t("3、豁免保密责任情形：3.1 在接触时已全网公开，或注册平台前就已合法持有该信息；3.2 合作方完全依靠自有资源、不参考对方涉密资料独立研发得到同类信息；3.3 合作方从无违约第三方渠道合法取得该信息，且该第三方不存在保密违约行为。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("十九、争议解决规则") }}</h3>
        <p class="content">
          {{ $t("1、本服务条款为本平台主协议；《Taoify 用户使用协议》《Taoify 用户隐私政策》等其他协议均为该主协议补充文件，整套文件共同构成您与平台完整约定。若任一补充文件条款与本主协议内容存在冲突、不一致，一律以本服务条款约定为准。针对本主协议未作出细化、未明确约定的事项，以《Taoify 用户使用协议》《Taoify 用户隐私政策》等其他协议约定内容为准。") }}
        </p>
        <p class="content">
          {{ $t("2、商户经营过程中产生的、与本服务条款相关的所有争议、索赔，统一由Taoify 平台运营主体所在地人民法院管辖。") }}
        </p>

        <p class="content">
          {{ $t("本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本条款更新日期：2026年1月1日。") }}
        </p>
        <p class="content">
          © {{ year }} Taoify · {{ $t("香港星橋國際貿易有限公司") }} · {{ $t("版权所有") }}
        </p>
      </v-container>
    </v-card>
  </v-app>
</template>

<script>
export default { data() { return { year: new Date().getFullYear() }; } };
</script>

<style lang="scss" scoped>
.titlee {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 25px;
  margin-top: 25px;
  margin-bottom: 10px;
}
.content {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
  color: #6a6e79;
}
li {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
  color: #6a6e79;
  margin-left: 20px;
  list-style: initial;
}
</style>
